import React from 'react';

function LoadingSpinner({ fullPage = false, size = 'md', label = '' }) {
  const sizeClass = size === 'lg' ? 'spinner spinner-lg' : 'spinner';

  if (fullPage) {
    return (
      <div
        style={{
          position: 'fixed',
          inset: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'var(--bg)',
          zIndex: 9999,
          gap: '16px',
        }}
      >
        <div className="spinner spinner-lg" />
        {label && <p style={{ color: 'var(--text-light)', fontSize: '0.9rem' }}>{label}</p>}
      </div>
    );
  }

  return (
    <div className="loading-center" style={{ flexDirection: 'column', gap: '12px' }}>
      <div className={sizeClass} />
      {label && <p style={{ color: 'var(--text-light)', fontSize: '0.9rem' }}>{label}</p>}
    </div>
  );
}

export default LoadingSpinner;
